import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8dfc3e70"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["data-id"]
const _hoisted_3 = { class: "product-element__container q-card q-h-100 q-p-3 q-shadow-sm q-rounded-3 q-position-relative q-bg-white q-overflow-hidden" }
const _hoisted_4 = {
  key: 0,
  class: "product-element__discount q-text-center q-text-white q-position-absolute q-discount q-p-1 q-bg-danger"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "q-discount-minus" }, "-", -1))
const _hoisted_6 = { class: "q-discount-discount" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "q-percentage" }, "%", -1))
const _hoisted_8 = { class: "product-element__image-container q-card-image" }
const _hoisted_9 = ["alt"]
const _hoisted_10 = { class: "product-element__info-box q-card-body" }
const _hoisted_11 = { class: "product-element__title q-mb-3 q-lh-base" }
const _hoisted_12 = ["href", "target"]

import AutocompletePriceBox from '@/components/AutocompletePopup/AutocompletePriceBox.vue'
import {ref, toRefs, inject, computed} from 'vue';
import {formatPrice, generateStaticImage, parsePrice, getDiscount, getRealPrice, addDisplayMacros} from '@/core/utils';
import {createTemplate} from "@/core/Template";
import {SmartSearchConfigInterface} from '@/core/types';

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion

export default /*#__PURE__*/_defineComponent({
  __name: 'ProductCard',
  props: ['product', 'component'],
  setup(__props) {

const SmartSearchConfig = ref(inject<SmartSearchConfigInterface>('SmartSearchConfig')!);

const {smallDevice, mediumDevice, largeDevice, extraLargeDevice} = SmartSearchConfig.value.serp.gridSettings.column;
const useStylisationUrl = !!SmartSearchConfig.value.appConfiguration.stylizationUrl;

const computedClass = computed(() => {
  return [
    `q-g-col-sm-${12 / smallDevice}`,
    `q-g-col-md-${12 / mediumDevice}`,
    `q-g-col-lg-${12 / largeDevice}`,
    `q-g-col-xl-${12 / extraLargeDevice}`,
  ];
});

const {currency: currencyCode} = SmartSearchConfig.value.appConfiguration;

const props = __props;
const {id, link, title, link_click, variants} = toRefs(props.product);

const firstVariant = ref(variants.value[0]);
const secondPrice = firstVariant.value.old_price || firstVariant.value.sale_price;

const {price, oldPrice} = getRealPrice(parsePrice(firstVariant.value.price), parsePrice(secondPrice));
const omnibusPrice = parsePrice(firstVariant.value.omnibus_price);

const {width, height, useQuarticImages} = SmartSearchConfig.value.serp.productImageSize;
const {removeDecimals} = SmartSearchConfig.value.appConfiguration;

const staticImage = computed(() => {
  const imageLink = firstVariant.value.image_link
  if (!useQuarticImages) {
    return imageLink
  }
  return imageLink ? generateStaticImage(imageLink, width, height) : generateStaticImage('https://static.quartic.com.pl/img/no-image/no-image.png', width, height);
})

const formattedPrice = ref(formatPrice(price, currencyCode, removeDecimals));
const formattedPriceOld = ref(formatPrice(oldPrice, currencyCode, removeDecimals));
const formattedOmnibusPrice = ref(formatPrice(omnibusPrice, currencyCode, removeDecimals));
const discount = ref(getDiscount(price, oldPrice));

const actualLink = ref(link.value);

const repairLink = (link: string) => link.replace(/^http:/, 'https:');

const handleClick = () => {
  if (useStylisationUrl) {
    actualLink.value = `${SmartSearchConfig.value.appConfiguration.stylizationUrl}/${id.value}`;
    return;
  }
  actualLink.value = repairLink(link_click.value);
};

const prepareClearLink = (link: string, clickLink: string) => {
  return ` href="${link}" data-href="${repairLink(clickLink)}" onmousedown="return this.href = this.getAttribute('data-href');" ontouchstart="return this.href = this.getAttribute('data-href');" `;
};

let generatedHtml = '';
if (props.component) {
  firstVariant.value.discount = discount.value;
  firstVariant.value.image_link_cdn = staticImage.value;
  firstVariant.value.price_formatted = formattedPrice.value;
  firstVariant.value.price_number = price;
  firstVariant.value.old_price_formatted = formattedPriceOld.value;
  firstVariant.value.old_price_number = oldPrice;
  firstVariant.value.omnibus_price_formatted = formattedOmnibusPrice.value;
  firstVariant.value.omnibus_price_number = omnibusPrice;
  firstVariant.value.id = id.value;
  firstVariant.value.link_click = link_click.value;
  firstVariant.value.clear_link = prepareClearLink(link.value, link_click.value);
  addDisplayMacros(firstVariant.value);
  generatedHtml = createTemplate(props.component, firstVariant.value, variants.value);
}


return (_ctx: any,_cache: any) => {
  const _directive_lazy = _resolveDirective("lazy")!

  return (__props.component)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["product-card-parent q-p-1 q-p-sm-2", computedClass.value]),
        innerHTML: _unref(generatedHtml)
      }, null, 10, _hoisted_1))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(["product-element q-p-1 q-p-sm-2", computedClass.value]),
        "data-id": _unref(id)
      }, [
        _createElementVNode("div", _hoisted_3, [
          (discount.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("span", _hoisted_6, _toDisplayString(discount.value), 1),
                _hoisted_7
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, [
            _withDirectives(_createElementVNode("img", {
              class: "product-element__image q-mx-auto q-d-block q-card-img-top q-img-fluid",
              alt: _unref(title)
            }, null, 8, _hoisted_9), [
              [_directive_lazy, staticImage.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("h6", _hoisted_11, _toDisplayString(_unref(title)), 1),
            (!useStylisationUrl)
              ? (_openBlock(), _createBlock(AutocompletePriceBox, {
                  key: 0,
                  product: firstVariant.value
                }, null, 8, ["product"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("a", {
            class: "product-element__link q-stretched-link",
            href: actualLink.value,
            onClick: handleClick,
            target: useStylisationUrl ? '_blank' : '_self'
          }, null, 8, _hoisted_12)
        ])
      ], 10, _hoisted_2))
}
}

})